import styled from '@emotion/styled';
import ContextContainer from "components/ui/ContextContainer";
import IsCoupon from "components/ui/Mytap/IsCoupon";
import { subscribeDataAtom } from "components/pages/MyTap/MyTapAtom";
import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, NumberSlice } from 'components/ui';

const Elem:React.FC<any> = () => {
  const [ subscribeData, setSubscribeData ] = useAtom(subscribeDataAtom);
  const [ payData, setPayData ] = useState<React.ReactNode>("");
  const [ price, setPrice ] = useState<React.ReactNode>(false);
  const navigate = useNavigate();

  const isSubs = subscribeData?.subsData[0];

  const handleSubsData = async () => {
    if (subscribeData?.isDiscount === false) {
      setPrice(
        <DataContainer>
          <span className="Title">결제 금액</span>
          <span className="contents">{(subscribeData?.estimatedAmount).toLocaleString()}원</span>
        </DataContainer>
      )
    } else {
      setPrice(
        <DataContainer>
          <TextContainer>
            <span className="Title">결제 금액</span>
            <CouponContainer>
              <IsCoupon>쿠폰할인</IsCoupon>
            </CouponContainer>
          </TextContainer>
          <PriceContainer>
            <NumberSlice />
            <span className="contents">{(subscribeData?.estimatedAmount).toLocaleString()}원</span>
          </PriceContainer>
        </DataContainer>
      )
    }
  }

  const handleCardData = async () => {
    if (subscribeData?.companyId === 1) {
      //카카오
      setPayData(
        <KakaoWrapper>
            <ImageWrapper>
              <Img src="/images/kakaoPayicon.png" alt="이미지" style={{ marginRight :"3px" }} />
            </ImageWrapper>
            카카오 페이
        </KakaoWrapper>
      )
    } else if (subscribeData?.companyId === 2) {
      // 페이플
      setPayData(
        <CardData>
          {subscribeData?.bank}
          <br /> {subscribeData?.cardNumber}
        </CardData>
        )
    } else {
      // 그 외 에러
      setPayData("구독 혹은 문의 부탁드리겠습니다.")
    }
  };

  const handleSeletedCardType = () => {
    navigate("/mypage/pay/change")
  };

  const handleUnsubscribe = () => {
    window.location.href = "/unsubscribe/confirm"
  };

  const handleGotoOnBoardingCredit=()=>{
    window.location.href ="/onboarding/2/detail"
  }

  useEffect(() => {
    handleSubsData()
  },[subscribeData])
  
  useEffect(() => {
    handleCardData()
  }, [subscribeData])



  return (
    <>
      {isSubs >1 ?(
        <>
          <Container>
            <FirstContainer>
              <SubTitle>결제 정보</SubTitle>
              <Context className="context">
                <span className="Title">결제 예정일</span>
                <span className="contents">{subscribeData?.payDay}</span>
              </Context>
              <Context className="context">
                {price}
              </Context>
            </FirstContainer>
            <SecontContainer>
              <SubTitle>결제 수단</SubTitle>
              <Context className="context">
                <DataContainer>
                  <span className="card">{payData}</span>
                  <ButtonWrapper
                    onClick={handleSeletedCardType}
                  >
                    변경
                  </ButtonWrapper>
                </DataContainer>
              </Context>
            </SecontContainer>
            <UnSubscribeWrapper
              onClick={handleUnsubscribe}
            >구독해지</UnSubscribeWrapper>
          </Container>
        </>
      ):(
        <>
          <Container className="unSubs">
            <UnsubsTextBox>
              구독중인 플랜이 없어요
            </UnsubsTextBox>
            <ButtonWrapper className="retry">
              <Button
                layoutVariant="contained"
                variant="default"
                expand
                onClick={handleGotoOnBoardingCredit}
              >재구독 요청</Button>
            </ButtonWrapper>
            </Container>
          </>
      )}
    </>
  )
}

export default Elem;

const Container = styled.div`
  width: 430px;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-right: auto;

  justify-content: space-between;
`
const FirstContainer = styled.div`
  width: 100%;
  height: 160px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const SubTitle = styled.div`
  height: 26px;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  color: var(---black);
  margin-bottom: 6px;
`

const Context = styled(ContextContainer)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  

  span {
    &.title{
      color:rgba(99, 99, 99, 1);
      font-family: 'Pretendard';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 26px;
    }
    &.contents{
      margin-right: 23px;
      color: var(--black);
    }
  }
`

const SecontContainer = styled.div`
  width: 100%;
  height: 104px;
  display: flex;
  flex-direction: column;
`
const DataContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const CouponContainer = styled.div`
width: 50px;
height: 15px;
`;
const PriceContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
`;
const KakaoWrapper =styled.div`
  display: flex; 
  flex-direction: row;
  align-items: center;
`;
const ImageWrapper = styled.div`
  width: 43px;
  height: 18px;
  
  margin-right: 10px;
  justify-content: center;
`;
const CardData = styled.div`
  line-height: 18px;
`;
const Img = styled.img`
  width: 100%;
  height: 100%;
`;
const UnsubsTextBox =styled.div`
  color:rgba(178, 178, 178, 1);
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 26px;
  margin: 250px auto 0;
`;
const ButtonWrapper = styled.div`
  width: 147px;
  height: 100%;
  text-align: right;

  padding-right: 16px ;
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 26px;
  text-align: right;
  color: #191919;

  &.retry{
    background-color: yellow;
    margin: 80px auto 0;
    width: 90%;
    height: 46px;
    padding-right: 0;
  }
`;
const UnSubscribeWrapper = styled.div`
  width: 52px;
  height: 26px;
  margin: 200px auto 63px;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 26px;
  display: flex;
  align-items: center;
  text-align: center;
  text-decoration-line: underline;
  color: #B1B1B1;
`;